import { AllGrnReturnResponse, GrnItemReturnResponse, GrnItemReturnResponseModel } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UnitRequest } from '../stock/dto/unit.id.request';
import { GrnDetailsForReturn } from './dto/grn-detail-for-return.dto';
import { GrnReturnIdRequest } from './dto/grn-return-id.request';
import { GrnReturnItemSaveDto } from './dto/grn-return-save.dto';
import { GrnReturnsService } from './grn-returns.service';
@ApiTags('GRN Returns')
@Controller('grn-returns')
export class GrnReturnsController {
    constructor(
        private grnReturnService: GrnReturnsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }

    @Post('/saveGrnReturns')
    async saveGrnReturns(@Body() grnRetunDto: GrnDetailsForReturn): Promise<GrnItemReturnResponseModel> {
        try {
            return await this.grnReturnService.saveGrnReturns(grnRetunDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GrnItemReturnResponseModel, error);
        }
    }

    @Post('/getAllGrnReturns')
    async getAllGrnReturns(@Body() req: UnitRequest): Promise<AllGrnReturnResponse> {
        try {
            return await this.grnReturnService.getAllGrnReturns(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllGrnReturnResponse, error);
        }
    }

    @Post('/getGrnReturnDataById')
    async getGrnReturnDataById(@Body() req: GrnReturnIdRequest): Promise<GrnItemReturnResponse> {
        try {
            return await this.grnReturnService.getGrnReturnDataById(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GrnItemReturnResponse, error);
        }
    }


}
